var _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path8, _path9, _path10, _path11, _path12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby6Weks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 231 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M114.976 27.1022C115.935 27.7272 114.647 31.1412 114.647 31.1412C114.647 31.1412 117.92 32.9162 117.622 34.0222C117.324 35.1282 113.644 34.8662 113.644 34.8662C113.644 34.8662 113.002 38.6192 111.859 38.6772C110.716 38.7352 109.792 35.0632 109.792 35.0632C109.792 35.0632 106.06 35.7032 105.651 34.6342C105.242 33.5652 108.415 31.4602 108.415 31.4602C108.415 31.4602 106.688 28.2002 107.578 27.4812C108.469 26.7622 111.416 29.0372 111.416 29.0372C111.416 29.0372 114.017 26.4772 114.976 27.1022Z",
    fill: "#FFF1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M120.92 0.0824184C121.724 0.606418 120.644 3.46742 120.644 3.46742C120.644 3.46742 123.387 4.95542 123.137 5.88242C122.887 6.80842 119.803 6.58942 119.803 6.58942C119.803 6.58942 119.265 9.73442 118.307 9.78342C117.349 9.83242 116.575 6.75442 116.575 6.75442C116.575 6.75442 113.447 7.29142 113.104 6.39542C112.761 5.49942 115.42 3.73541 115.42 3.73541C115.42 3.73541 113.972 1.00242 114.718 0.400419C115.464 -0.201581 117.935 1.70442 117.935 1.70442C117.935 1.70442 120.116 -0.441582 120.92 0.0824184Z",
    fill: "#FFF1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M87.0479 4.39954C88.4219 5.29454 86.5769 10.1865 86.5769 10.1865C86.5769 10.1865 91.2659 12.7305 90.8389 14.3135C90.4119 15.8975 85.1399 15.5225 85.1399 15.5225C85.1399 15.5225 84.2199 20.8995 82.5819 20.9825C80.9439 21.0665 79.6209 15.8045 79.6209 15.8045C79.6209 15.8045 74.2729 16.7225 73.6879 15.1905C73.1019 13.6585 77.6479 10.6425 77.6479 10.6425C77.6479 10.6425 75.1729 5.97154 76.4489 4.94154C77.7249 3.91154 81.9469 7.17054 81.9469 7.17054C81.9469 7.17054 85.6739 3.50454 87.0479 4.39954Z",
    fill: "#FFF1C8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M115.367 132.891C179.082 132.891 230.734 127.179 230.734 120.134C230.734 113.088 179.082 107.377 115.367 107.377C51.6516 107.377 0 113.088 0 120.134C0 127.179 51.6516 132.891 115.367 132.891Z",
    fill: "#FFB95F",
    fillOpacity: 0.96
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M126.404 49.1642C126.358 49.3102 126.317 49.4572 126.283 49.6092C126.329 49.4062 126.588 49.1422 126.709 48.9732C126.864 48.7562 127.026 48.5432 127.194 48.3362C127.499 47.9612 127.724 47.5532 128.19 47.3502C128.589 47.1762 129.126 47.2402 129.365 47.6042C129.599 47.9622 129.468 48.4362 129.32 48.8372C129.049 49.5712 128.744 50.2922 128.407 50.9972C128.984 50.3822 130.992 48.2092 131.563 49.7872C131.909 50.7432 130.745 52.8182 130.344 53.6632C130.498 53.3392 131.03 53.1112 131.326 52.9542C131.717 52.7462 132.14 52.5082 132.598 52.6062C132.919 52.6742 133.217 52.8992 133.314 53.2122C133.384 53.4382 133.345 53.6872 133.253 53.9062C132.965 54.5932 132.402 55.0982 131.939 55.6662C130.804 57.0592 129.657 58.4432 128.499 59.8172C126.983 61.6142 125.91 62.4082 125.654 64.8782C124.613 74.9192 118.55 88.7562 107.561 91.1132C97.7258 93.2222 86.7038 89.3052 80.7068 81.1582C79.1108 78.9902 78.2558 74.4202 80.2768 72.6412C82.0658 71.0672 84.5728 70.6362 86.9498 70.4682C92.7068 70.0622 98.5438 70.8372 103.995 72.7322C106.348 67.7912 111.568 63.6512 115.473 59.8182C116.434 58.8752 117.247 58.0412 117.222 56.6812C117.193 55.0752 117.174 53.4692 117.191 51.8632C117.195 51.5132 117.201 51.1542 117.326 50.8262C117.451 50.4992 117.72 50.2042 118.066 50.1482C118.476 50.0822 118.871 50.3662 119.095 50.7162C119.319 51.0652 119.419 51.4782 119.576 51.8622C119.668 52.0872 119.791 52.3152 119.999 52.4432C120.342 52.6532 120.811 52.5092 121.093 52.2232C121.792 51.5152 122.255 50.4822 122.857 49.6852C123.582 48.7262 124.368 47.8132 125.21 46.9552C125.486 46.6742 125.888 46.3762 126.303 46.3702C126.519 46.3672 126.739 46.4632 126.864 46.6392C127.029 46.8732 127.001 47.1892 126.945 47.4702C126.88 47.7942 126.788 48.1122 126.669 48.4202C126.576 48.6682 126.483 48.9132 126.404 49.1642Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.5,
    d: "M123.99 51.0947C126.173 51.9867 128.095 53.5077 129.464 55.4287",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M130.982 93.5615C127.66 85.7605 128.443 74.6224 130.628 67.4184C133.225 58.8574 140.289 50.9945 149.211 50.3435C156.417 49.8175 163.098 53.9265 168.844 58.3075C170.134 62.6775 171.15 70.2705 169.699 74.5895C166.836 74.3195 163.626 74.9675 160.763 74.6975C164.779 79.6445 165.937 88.7314 162.236 93.9184C158.535 99.1054 152.167 101.951 145.817 102.49C137.998 103.154 133.401 99.2425 130.982 93.5615Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M168.754 57.7587C169.89 58.1417 172.473 59.5977 173.623 59.4007C174.579 59.2367 175.569 57.5067 176.342 56.7807C178.445 54.8037 180.958 53.2597 183.68 52.2947C184.944 51.8467 186.353 51.5247 187.606 52.0017C188.754 52.4377 189.584 53.5007 189.981 54.6627C190.378 55.8247 190.392 57.0837 190.295 58.3077C189.593 67.2027 182.847 76.2407 173.372 76.1447C170.751 76.1177 168.259 75.5247 165.826 74.8907C165.908 69.6347 167.478 63.0077 168.754 57.7587Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M165.944 74.8056C166.548 69.0526 167.613 63.3476 169.126 57.7646",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M145.87 53.1065C148.395 54.5105 151.692 54.3935 154.112 52.8145",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M65.7569 102.543C65.7569 102.543 61.2629 122.677 116.252 125.43C171.241 128.183 170.616 92.6822 170.616 92.6822C170.616 92.6822 171.703 64.0952 130.667 72.9682C130.667 72.9682 122.55 64.5922 96.2359 70.4452C69.9209 76.2992 65.7569 102.543 65.7569 102.543Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.5,
    d: "M103.67 97.7237C101.486 93.3567 108.278 80.0077 106.32 68.7607C103.299 69.0837 99.9549 69.6187 96.2339 70.4457C69.9189 76.2987 65.7559 102.544 65.7559 102.544C65.7559 102.544 61.262 122.678 116.251 125.431C171.24 128.184 170.615 92.6827 170.615 92.6827C170.615 92.6827 170.763 88.7107 168.828 84.1877C150.213 104.341 120.153 122.447 103.67 97.7237Z",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M92.9219 49.8965C94.6039 53.2565 98.9939 54.5475 101.417 57.4365C108.355 65.7075 107.759 78.7585 103.02 87.9436C99.2749 95.2016 92.0669 99.7255 84.8879 103.088C80.7499 105.026 76.2279 106.34 71.6619 106.157C64.7889 105.882 59.4439 102.07 53.4729 99.2445C46.0019 95.7105 38.6889 90.6286 34.3659 83.4396C31.8879 79.3186 30.3359 74.6725 29.8649 69.8865C28.5819 56.8755 35.1049 44.1345 45.6979 36.7155C49.1569 34.2925 52.9579 32.3475 56.9419 30.9485C63.4889 28.6495 70.8389 29.1485 77.1119 32.0605C84.6119 35.5425 89.5079 42.2465 92.8009 49.6395C92.8399 49.7275 92.8799 49.8125 92.9219 49.8965Z",
    fill: "#876855"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M43.1329 96.3894C41.8989 98.5364 42.9699 101.414 44.8719 103.001C46.7739 104.588 49.2809 105.199 51.6929 105.763C52.6179 105.979 53.5699 106.197 54.5109 106.065C55.8089 105.882 56.9419 105.04 57.7519 104.01C58.5619 102.979 59.0949 101.763 59.6189 100.561C59.7269 100.314 59.8369 100.052 59.8039 99.7854C59.5979 98.1174 54.8129 94.5264 53.1089 93.9404C50.2219 92.9464 44.7919 93.5024 43.1329 96.3894Z",
    fill: "#876855"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.3,
    d: "M93.8128 58.3255C92.4568 58.8775 91.3058 59.9735 90.7188 61.3255C89.4288 64.2975 90.6389 67.8715 93.6689 69.0175C94.8189 69.4525 96.1138 69.6715 97.2738 69.2645C97.8318 69.0685 98.3318 68.7365 98.8038 68.3805C99.4178 67.9175 100.001 67.4045 100.46 66.7875C102.912 63.4935 99.9548 58.1005 95.9288 57.9435C95.2028 57.9135 94.4828 58.0525 93.8128 58.3255Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.3,
    d: "M63.47 81.851C61.972 82.46 60.701 83.671 60.053 85.164C58.628 88.446 59.964 92.393 63.312 93.659C64.582 94.139 66.012 94.382 67.293 93.931C67.909 93.714 68.461 93.348 68.983 92.955C69.661 92.444 70.305 91.877 70.812 91.196C73.52 87.558 70.254 81.602 65.808 81.428C65.005 81.396 64.21 81.55 63.47 81.851Z",
    fill: "#1D1D1B"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M45.9379 97.0771C44.5989 98.1361 44.5869 100.385 45.8259 101.516C45.9949 101.67 46.2149 101.463 46.2019 101.282C46.0839 99.5701 45.2629 98.3561 47.2609 97.3671C47.3179 98.7901 48.4308 100.815 49.7898 101.133C50.0808 101.201 50.3179 100.917 50.1319 100.654C49.7169 100.069 49.0949 99.6831 48.6939 99.0621C48.2919 98.4381 48.1539 97.7751 47.9399 97.0921C49.0679 96.7261 50.2909 96.7431 51.4519 96.9151C51.6129 96.9391 51.7179 96.6911 51.5669 96.6071C49.9729 95.7181 47.3879 95.9311 45.9379 97.0771Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M61.203 69.262C61.434 69.029 61.667 68.786 61.8 68.486C61.933 68.186 61.947 67.811 61.752 67.547C61.542 67.263 61.141 67.174 60.795 67.249C60.449 67.324 60.149 67.531 59.87 67.747C58.528 68.783 57.423 70.127 56.681 71.652C56.569 71.882 56.464 72.122 56.453 72.377C56.379 74.041 57.939 72.253 58.27 71.973C59.287 71.112 60.266 70.208 61.203 69.262Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M86.274 50.6237C86.634 50.3727 87.041 49.9507 86.831 49.5647C86.626 49.1887 86.066 49.2847 85.669 49.4457C83.982 50.1327 82.393 51.0587 80.965 52.1887C79.541 53.3147 79.755 55.1697 81.656 53.8437C83.196 52.7707 84.735 51.6967 86.274 50.6237Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M84.3929 69.5052C82.9009 67.9302 80.5789 69.1572 79.4299 70.4982C79.3709 70.5672 79.4619 70.6422 79.5309 70.6062C80.8599 69.9052 82.9649 68.3182 84.1769 70.1602C85.1379 71.6202 84.1849 73.3542 83.3949 74.6372C83.2339 74.8982 83.6919 75.1862 83.8569 74.9232C84.8219 73.3752 85.9069 71.1042 84.3929 69.5052Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M87.0748 82.9095C85.0708 84.3345 83.0768 85.4544 80.5448 85.5354C78.2138 85.6104 76.3628 84.8104 74.2688 83.9324C74.1368 83.8774 74.0498 84.0414 74.1428 84.1354C77.6698 87.6994 84.3298 86.9474 87.6248 83.4974C87.9468 83.1604 87.4418 82.6485 87.0748 82.9095Z",
    fill: "#4E4E4E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_384_682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 56,
    width: 10,
    height: 8
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119810098982560802640000009968599094007447716_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M91.8989 57.7641C91.3929 58.6831 90.7209 59.5511 89.9279 60.3231C88.8229 61.4071 87.4829 62.3071 86.0739 62.9431C85.1179 63.3751 84.1199 63.6931 83.1409 63.8541C83.0039 62.9101 82.8889 61.9231 82.9199 60.9771C82.9439 59.8921 83.1659 58.8491 83.7729 57.9621C84.6429 56.6931 86.2129 56.0081 87.7449 56.0391C88.1249 56.0421 88.5119 56.0931 88.8799 56.1701L88.8949 56.1731C90.0099 56.4241 91.0459 57.0031 91.8989 57.7641Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_384_682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M91.8989 57.7641C91.3929 58.6831 90.7209 59.5511 89.9279 60.3231C88.8229 61.4071 87.4829 62.3071 86.0739 62.9431C85.1179 63.3751 84.1199 63.6931 83.1409 63.8541C83.0039 62.9101 82.8889 61.9231 82.9199 60.9771C82.9439 59.8921 83.1659 58.8491 83.7729 57.9621C84.6429 56.6931 86.2129 56.0081 87.7449 56.0391C88.1249 56.0421 88.5119 56.0931 88.8799 56.1701L88.8949 56.1731C90.0099 56.4241 91.0459 57.0031 91.8989 57.7641Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_384_682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 56,
    width: 10,
    height: 8
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119810098982560802640000009968599094007447716__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M91.8989 57.7641C91.3929 58.6831 90.7209 59.5511 89.9279 60.3231C88.8229 61.4071 87.4829 62.3071 86.0739 62.9431C85.1179 63.3751 84.1199 63.6931 83.1409 63.8541C83.0039 62.9101 82.8889 61.9231 82.9199 60.9771C82.9439 59.8921 83.1659 58.8491 83.7729 57.9621C84.6429 56.6931 86.2129 56.0081 87.7449 56.0391C88.1249 56.0421 88.5119 56.0931 88.8799 56.1701L88.8949 56.1731C90.0099 56.4241 91.0459 57.0031 91.8989 57.7641Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_384_682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M83.1748 58.4714C82.2438 59.9424 82.3648 62.0024 83.4608 63.3554C84.5568 64.7084 86.5468 65.2524 88.1788 64.6464C89.8108 64.0404 90.9638 62.3294 90.9118 60.5894C90.7928 56.5404 85.3398 55.0474 83.1748 58.4714Z",
    fill: "#4E505B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_384_682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 71,
    width: 10,
    height: 9
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000059303616493020141720000001991938950054764462_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M70.113 73.2367C69.607 74.1557 68.935 75.0237 68.142 75.7957C67.037 76.8797 65.697 77.7797 64.288 78.4157C63.332 78.8477 62.334 79.1658 61.355 79.3268C61.218 78.3828 61.104 77.3957 61.134 76.4497C61.158 75.3647 61.38 74.3217 61.987 73.4347C62.857 72.1657 64.427 71.4808 65.959 71.5118C66.339 71.5148 66.726 71.5657 67.094 71.6427L67.109 71.6458C68.224 71.8968 69.26 72.4757 70.113 73.2367Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_384_682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M70.113 73.2367C69.607 74.1557 68.935 75.0237 68.142 75.7957C67.037 76.8797 65.697 77.7797 64.288 78.4157C63.332 78.8477 62.334 79.1658 61.355 79.3268C61.218 78.3828 61.104 77.3957 61.134 76.4497C61.158 75.3647 61.38 74.3217 61.987 73.4347C62.857 72.1657 64.427 71.4808 65.959 71.5118C66.339 71.5148 66.726 71.5657 67.094 71.6427L67.109 71.6458C68.224 71.8968 69.26 72.4757 70.113 73.2367Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_384_682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 71,
    width: 10,
    height: 9
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000059303616493020141720000001991938950054764462__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M70.113 73.2367C69.607 74.1557 68.935 75.0237 68.142 75.7957C67.037 76.8797 65.697 77.7797 64.288 78.4157C63.332 78.8477 62.334 79.1658 61.355 79.3268C61.218 78.3828 61.104 77.3957 61.134 76.4497C61.158 75.3647 61.38 74.3217 61.987 73.4347C62.857 72.1657 64.427 71.4808 65.959 71.5118C66.339 71.5148 66.726 71.5657 67.094 71.6427L67.109 71.6458C68.224 71.8968 69.26 72.4757 70.113 73.2367Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_384_682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M61.189 73.635C60.258 75.106 60.379 77.166 61.475 78.519C62.571 79.872 64.561 80.416 66.193 79.81C67.825 79.204 68.978 77.493 68.926 75.753C68.807 71.704 63.354 70.212 61.189 73.635Z",
    fill: "#4E505B"
  })))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    opacity: 0.8,
    d: "M47.1968 48.8958C55.6368 51.5418 65.3788 49.5438 72.0948 43.7888C73.8348 42.2978 75.4358 40.4698 75.9318 38.2328C76.4278 35.9958 75.4838 33.3168 73.3568 32.4648",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    opacity: 0.8,
    d: "M41.2519 53.0654C35.3599 62.7484 37.2159 76.5544 41.8399 84.7404",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    opacity: 0.8,
    d: "M49.7058 44.1518C52.4908 44.6838 55.4818 44.0398 57.8018 42.4098C60.1218 40.7798 61.7408 38.1848 62.1848 35.3838",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    opacity: 0.8,
    d: "M38.7559 50.4482C32.4279 55.6202 29.6769 64.7682 32.1019 72.5722",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    opacity: 0.8,
    d: "M66.7759 41.3374C68.3969 39.5374 69.2989 37.1094 69.2469 34.6874C69.1949 32.2664 68.1889 29.8784 66.4929 28.1494",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M135.393 112.735C135.399 112.321 135.415 111.909 135.439 111.501C136.339 96.0581 149.756 72.5731 168.328 76.8661C175.368 78.4931 180.535 84.3941 184.73 90.2771C184.671 94.8341 183.397 102.387 180.734 106.085C179.022 105.373 174.89 103.614 173.081 103.891C171.167 104.184 171.972 106.228 171.741 107.987C171.099 112.862 167.999 117.332 164.037 120.135C159.193 123.563 153.055 124.822 147.127 124.564C143.721 124.415 140.063 123.647 137.807 121.091C135.838 118.862 135.349 115.748 135.393 112.735Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M184.393 89.139C185.612 90.019 187.009 91.453 188.392 92.025C189.884 92.642 190.196 91.887 191.634 91.046C194.063 89.625 196.813 88.748 199.619 88.523C201.613 88.363 203.858 88.631 205.162 90.149C206.05 91.182 206.328 92.639 206.159 93.991C205.99 95.343 205.419 96.611 204.769 97.809C200.628 105.434 192.402 112.757 183.276 109.832C180.547 108.957 178.137 107.532 175.801 106.084C177.585 100.622 181.365 94.208 184.393 89.139Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M175.952 106.034C178.441 100.221 181.397 94.6066 184.782 89.2656",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    opacity: 0.5,
    d: "M167.732 78.9941C166.708 80.4461 165.162 81.5221 163.445 81.9781C161.728 82.4341 159.852 82.2671 158.242 81.5141",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    opacity: 0.5,
    d: "M169.2 95.3184C170.559 97.4924 171.525 99.9124 172.038 102.424",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M120.539 95.8577C120.439 95.9727 120.343 96.0917 120.251 96.2177C120.374 96.0497 120.717 95.9107 120.895 95.8037C121.124 95.6657 121.357 95.5357 121.593 95.4127C122.022 95.1897 122.391 94.9047 122.9 94.9047C123.336 94.9037 123.803 95.1757 123.877 95.6047C123.949 96.0257 123.641 96.4087 123.345 96.7177C122.805 97.2827 122.238 97.8236 121.648 98.3366C122.422 98.0026 125.129 96.8077 125.025 98.4827C124.962 99.4977 123.069 100.938 122.364 101.554C122.634 101.318 123.213 101.321 123.547 101.294C123.988 101.259 124.471 101.209 124.853 101.481C125.12 101.671 125.304 101.996 125.268 102.322C125.242 102.558 125.107 102.77 124.936 102.935C124.398 103.451 123.681 103.69 123.03 104.027C121.434 104.854 119.832 105.667 118.222 106.466C116.116 107.512 114.816 107.813 113.598 109.977C108.648 118.774 97.5779 129.056 86.5599 126.845C76.6979 124.866 68.1449 116.887 65.8849 107.026C65.2839 104.402 66.3179 99.8687 68.8799 99.0407C71.1469 98.3087 73.6189 98.9107 75.8659 99.7027C81.3089 101.622 86.3559 104.656 90.6029 108.563C94.7279 104.966 101.164 103.246 106.273 101.283C107.53 100.8 108.608 100.359 109.126 99.1007C109.738 97.6157 110.36 96.1357 111.015 94.6677C111.158 94.3477 111.307 94.0207 111.551 93.7707C111.796 93.5197 112.16 93.3566 112.499 93.4426C112.901 93.5456 113.151 93.9636 113.217 94.3736C113.283 94.7836 113.211 95.2007 113.203 95.6157C113.198 95.8597 113.22 96.1177 113.36 96.3167C113.591 96.6457 114.079 96.7007 114.451 96.5507C115.374 96.1787 116.21 95.4157 117.08 94.9237C118.127 94.3317 119.211 93.8077 120.325 93.3557C120.69 93.2077 121.177 93.0946 121.561 93.2546C121.76 93.3376 121.924 93.5136 121.968 93.7246C122.026 94.0056 121.874 94.2836 121.711 94.5196C121.523 94.7906 121.311 95.0456 121.08 95.2806C120.894 95.4706 120.711 95.6587 120.539 95.8577Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M71.0088 101.022C81.5318 99.5474 88.7538 105.886 88.7538 105.886C88.7538 105.886 88.1908 114.81 73.6348 122.984C73.6348 122.984 56.5198 108.131 71.0088 101.022Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M73.1267 123.343C80.4597 120.073 86.2207 113.458 88.4517 105.745",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    opacity: 0.5,
    d: "M90.1658 125.658C91.6638 124.321 93.8768 123.838 95.7958 124.43",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby6Weks);
export default __webpack_public_path__ + "static/media/baby-6-weks.145f003623205fe0528ef6575aea1414.svg";
export { ForwardRef as ReactComponent };